import { inject, provide, ref } from "vue";

/**
 * @description 画面（route）遷移後、画面のscrollbarをtopにする
 */
export function provideScrollToTopFunc() {
  const scrollbar = ref();

  const resetScrollToTop = () => {
    if (scrollbar.value) {
      scrollbar.value.wrap.scrollTop = 0;
    }
  };

  provide("resetScrollbar", resetScrollToTop);

  return scrollbar;
}

export function injectScrollToTop() {
  const scrollToTop = inject("resetScrollbar") as () => void;
  scrollToTop();
}
